import script from "./ChannelIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelIndex.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelIndex.vue?vue&type=style&index=0&id=c81640c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c81640c6"]])

export default __exports__